import { RefundView } from "@/components/common/account/AccountViews";

export default function RefundMobile() {
  return <RefundView isMobile={true} />;
}
